import { formatCurrency, ProductOffering } from '@travelwin/core';

import { useLocaleUtils } from '../../hooks/useLocaleUtils';

type PostPlanPriceProps = {
  plan: ProductOffering;
};

export const PostPlanPrice = ({ plan }: PostPlanPriceProps) => {
  const { currentLocale } = useLocaleUtils();

  return formatCurrency(
    currentLocale,
    plan.product_offering_pricing[0].currency.alias,
    plan.product_offering_pricing[0].total_price_gross,
  );
};
